import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { GoogleAnalyticsService } from "shared/services";
import { currentUserSelector } from "Auth/state";

export const useGoogleAnalytics = () => {
  const currentUser = useSelector(currentUserSelector);
  const { pathname, search } = useLocation();

  // initialize Google Analytics if acceptAll cookie is set
  useEffect(() => {
    GoogleAnalyticsService.initialize();
  }, []);

  // add current user to Google Analytics
  useEffect(() => {
    GoogleAnalyticsService.setUser(currentUser);
  }, [currentUser]);

  // send page view to google analytics on path change
  useEffect(() => {
    GoogleAnalyticsService.pageView(`${pathname}${search}`);
  }, [pathname, search]);
};
